var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkgradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 964,
    height: 964,
    viewBox: "0 0 964 964",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_139_1986)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 482,
    r: 176,
    fill: "url(#paint0_radial_139_1986)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_139_1986",
    x: 0.100006,
    y: 0.100006,
    width: 963.8,
    height: 963.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 152.95,
    result: "effect1_foregroundBlur_139_1986"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_139_1986",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(423.958 415.426) rotate(-29.4397) scale(135.448 485.568)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#DD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF0048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#DD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0048"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkgradient);
export default __webpack_public_path__ + "static/media/pinkgradient.0c82af27ad42a211cc2eba608f3e4d7d.svg";
export { ForwardRef as ReactComponent };